<section
  #dialogSection
  role="dialog"
  aria-modal="true"
  aria-labelledby="dialog-title"
  data-testid="online-cities-dialog-root"
  class="rounded-4xl relative mx-auto min-w-[280px] max-w-[95%] bg-white px-6 pb-6 pt-12 text-blue-900 md:max-w-[840px] md:px-10 md:pb-10"
>
  <csl-icon
    #closeButton
    name="x-32"
    class="absolute right-4 top-4 size-8 cursor-pointer bg-gray-800"
    (click)="close()"
    aria-label="Close dialog"
    role="button"
    tabindex="0"
    (keydown.enter)="close()"
    (keydown.space)="$event.preventDefault(); close()"
    data-testid="close-dialog"
  ></csl-icon>
  <h4 #dialogTitle id="dialog-title" class="text-center text-xl font-bold md:text-2xl">
    Online Service {{ isResidentialService() ? 'Order' : 'Request' }} Areas
  </h4>
  <p class="mb-5 mt-4">
    Online service {{ isResidentialService() ? 'order' : 'request' }} is available only in certain areas grouped by
    states, which you can check below:
  </p>
  <!--
    IMPORTANT!
    Modal's scrollable content.
    Please check the dialog on the mobile and desktop screens on both: portrait and landscape modes. Specify max-height according to available space.
    Note: if the dialog's height fits in the landscape mode of Desktop screen (>768px), you most likely don't have to specify max-height.
  -->
  <div class="relative max-h-[60vh] overflow-y-auto text-sm" #scrollContainer>
    <cdk-accordion class="flex flex-col gap-2">
      @for (section of stateSections; track section) {
        <details
          [expanded]="$last"
          cdkAccordionItem
          #accordionItem="cdkAccordionItem"
          [open]="accordionItem.expanded"
          [attr.data-testid]="'state-section-' + section.state"
        >
          <summary
            [id]="'section-tab-' + section.state"
            class="sticky top-0 list-none marker:hidden after:absolute after:block after:h-2 after:w-full after:bg-gradient-to-b after:from-white after:to-transparent"
            (click)="accordionItem.toggle(); $event.preventDefault()"
            role="button"
            [attr.aria-expanded]="accordionItem.expanded"
            [attr.aria-controls]="'cities-' + section.state"
            #sectionTab
          >
            <div
              class="flex w-full cursor-pointer justify-between rounded-xl bg-gray-100 px-4 py-3"
              data-testid="section-summary"
            >
              <dl class="flex gap-1">
                <dt class="font-medium">{{ section.state }}</dt>
                <dd class="text-gray-750">({{ section.citiesCount }})</dd>
              </dl>
              <csl-icon
                name="dropdown-arrow"
                class="bg-gray-750 mr-2 inline-block size-6"
                [ngClass]="{ 'rotate-180': accordionItem.expanded }"
              ></csl-icon>
            </div>
          </summary>
          <div
            [id]="'cities-' + section.state"
            class="transition-height-container"
            [ngClass]="{ 'open p-2': accordionItem.expanded }"
            role="region"
            [attr.aria-labelledby]="'section-tab-' + section.state"
          >
            <div class="transition-height-content">
              <div class="[column-count:1] md:[column-count:3] md:[column-gap:1.25rem]">
                @for (group of section.citiesGroups; track group) {
                  <ul class="mb-5 ml-4 list-disc [break-inside:avoid]">
                    @for (city of group; track city) {
                      <li data-testid="city-item">{{ city }}</li>
                    }
                  </ul>
                }
              </div>
            </div>
          </div>
        </details>
      }
    </cdk-accordion>
  </div>
</section>
